import { ICommonSettings, IPushNotificationSetting, IPushNotificationSettingWeb } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigPushNotification, PUSH_NOTIFICATION_SEARCH_TERMS } from "./app-settings-config-push-notification";
import { ConfigPushNotificationWeb } from "./app-settings-config-push-notification-web";

export interface IConfigPushNotificationInputState {
  showModal: boolean;
  editingPushNotificationId: string;
}

export interface IConfigPushNotificationInputProps {
  parentData: string;
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigPushNotificationInput extends PureComponent<
  IConfigPushNotificationInputProps,
  IConfigPushNotificationInputState
> {
  formInputName = ["", "pushNotificationSettingsId"];

  constructor(props: IConfigPushNotificationInputProps) {
    super(props);
    this.formInputName[0] = this.props.parentData;
    this.state = {
      showModal: false,
      editingPushNotificationId: ""
    };
  }

  openModal = () => {
    this.setState({ editingPushNotificationId: "", showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingPushNotification = (id: string) => {
    this.setState({ editingPushNotificationId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options =
      this.formInputName[0] === "iosConfig"
        ? [
            {
              id: null,
              name: "Default"
            } as unknown as IPushNotificationSetting,
            ...(commonSettings.pushNotificationSettings || [])
          ]
        : [
            {
              id: null,
              name: "Default"
            } as unknown as IPushNotificationSettingWeb,
            ...(commonSettings.pushNotificationSettingsWeb || [])
          ];
    return (
      <>
        {this.formInputName[0] === "iosConfig" ? (
          <ConfigPushNotification
            formInputName={this.formInputName}
            closeModal={this.closeModal}
            showModal={this.state.showModal}
            editingPushNotificationId={this.state.editingPushNotificationId}
            commonSettings={commonSettings}
            getSectionDescription={getSectionDescription}
            handleCreateCommonConfig={handleCreateCommonConfig}
            handleUpdateCommonConfig={handleUpdateCommonConfig}
            handleDeleteCommonConfig={handleDeleteCommonConfig}
          />
        ) : (
          <ConfigPushNotificationWeb
            formInputName={this.formInputName}
            closeModal={this.closeModal}
            showModal={this.state.showModal}
            editingPushNotificationId={this.state.editingPushNotificationId}
            commonSettings={commonSettings}
            getSectionDescription={getSectionDescription}
            handleCreateCommonConfig={handleCreateCommonConfig}
            handleUpdateCommonConfig={handleUpdateCommonConfig}
            handleDeleteCommonConfig={handleDeleteCommonConfig}
          />
        )}

        <ConfigSettingSelect
          // The same condition the dialog above follows: this row draws the iOS dialog or
          // the web one, and only the iOS dialog has a list of its fields so far.
          searchTerms={this.formInputName[0] === "iosConfig" ? PUSH_NOTIFICATION_SEARCH_TERMS : undefined}
          label="Settings"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey="ios_pushnotification_settings"
          onAddNew={this.openModal}
          onEdit={this.setEditingPushNotification}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId={this.props.parentData + "PushNotificationSettingsDropdown"}
          addNewTestId={this.props.parentData + "PushNotificationSettingsAddNewButton"}
          editTestId={this.props.parentData + "PushNotificationSettingEditButton"}
        />
      </>
    );
  }
}
